import { render } from "./SentencePart.vue?vue&type=template&id=1911856e&scoped=true"
import script from "./SentencePart.vue?vue&type=script&lang=js"
export * from "./SentencePart.vue?vue&type=script&lang=js"

import "./SentencePart.vue?vue&type=style&index=0&id=1911856e&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-1911856e"

export default script